/** Marketing / store / contact — override via Vite env when store URLs go live. */

export const CONTACT = {
  phone: '(+212) 682 120 188',
  phoneHref: 'tel:+212682120188',
  email: 'contact@omnivatis.com',
  emailHref: 'mailto:contact@omnivatis.com?subject=DriveOps',
  address: 'Apt. 3, 1st Fl., Res. Rif II, Bldg. No. B01, Temara. Morocco',
  mapsHref:
    'https://www.google.com/maps/search/?api=1&query=Residence+Rif+II+Temara+Morocco',
  company: 'Omnivatis Synergy',
} as const

/** Android package is live in the project; Play listing may still be rolling out. */
export const STORE = {
  android:
    import.meta.env.VITE_PLAY_STORE_URL ??
    'https://play.google.com/store/apps/details?id=com.omnivatis.driveops',
  ios: import.meta.env.VITE_APP_STORE_URL ?? '',
  packageId: 'com.omnivatis.driveops',
} as const

export const SERVICES = [
  {
    id: 'live',
    title: 'Live fleet tracking',
    text: 'See every vehicle on the map with ignition, speed, fuel, and battery from Teltonika trackers — updated as they move.',
  },
  {
    id: 'history',
    title: 'Trip history & replay',
    text: 'Open any day, follow the route on the map, and share the same timeline with dispatch and support.',
  },
  {
    id: 'reports',
    title: 'Distance & engine reports',
    text: 'Measure kilometres driven, engine hours, and idle time over the ranges your ops team already asks for.',
  },
  {
    id: 'plans',
    title: 'Plans, payments & alerts',
    text: 'Onboard vehicles, manage subscriptions, and keep drivers and admins notified when something needs attention.',
  },
] as const
